import React from 'react';
import { useFeatureIsOn } from '@monofront/business/contexts';
import { FEATURE_FLAG_NEW_MEMBERSHIP_PRODUCT_CART } from '@monofront/business/constants';
import MembershipProductVersionA from './MembershipProduct-versionA';
import MembershipProductVersionB from './MembershipProduct-versionB';

interface IMembershipProductProps {
  isSideShoppingCart?: boolean;
  isImageLarge?: boolean;
}

const MembershipProduct: React.FC<IMembershipProductProps> = ({
  isSideShoppingCart = false,
  isImageLarge = false,
}) => {
  const isNewMembershipCartDisplayed = useFeatureIsOn(
    FEATURE_FLAG_NEW_MEMBERSHIP_PRODUCT_CART,
  );

  if (isNewMembershipCartDisplayed)
    return (
      <MembershipProductVersionB
        isSideShoppingCart={isSideShoppingCart}
        isImageLarge={isImageLarge}
      />
    );

  return <MembershipProductVersionA />;
};

export default MembershipProduct;
